export var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '2.18.0',
};
//# sourceMappingURL=buildEnv.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datadog/browser-rum-core/esm/boot/buildEnv.js
// module id = 1617
// module chunks = 0